module.exports = __webpack_public_path__ + "img/cloth_g3_shoe-02.d1d4bf2e.svg";